var map = {
	"./a-table-icon.svg": "675f",
	"./accordion-arrow.svg": "1ac0",
	"./add-flight-icon.svg": "a844",
	"./add-icon.svg": "dd04",
	"./alcohol-icon.svg": "113d",
	"./altezza-logo.svg": "93e6",
	"./amex.svg": "3ce8",
	"./amount-icon.svg": "4c0c",
	"./approved-icon.svg": "d915",
	"./arrow-back.svg": "95cd",
	"./arrow-left-icon.svg": "719c",
	"./arrow-spoiler.svg": "09ed",
	"./auth-logo.svg": "920f",
	"./billing-address-icon.svg": "6122",
	"./bus-icon.svg": "04b0",
	"./calendar-icon.svg": "1b93",
	"./cancel-icon.svg": "faec",
	"./car-icon.svg": "fd15",
	"./cardiogram.svg": "31f2",
	"./checkbox-checked.svg": "3b83",
	"./checklist-icon.svg": "5c63",
	"./climbing-table-icon.svg": "7a1e",
	"./clock-snacks.svg": "1404",
	"./communication.svg": "f54e",
	"./contact-details.svg": "1a69",
	"./covid-vaccine.svg": "66c3",
	"./credit-card.svg": "873d",
	"./cropper/bx_bx-minus-circle.svg": "d85c",
	"./cropper/bx_bx-plus-circle.svg": "d417",
	"./cropper/bx_bx-rotate-left.svg": "5164",
	"./cropper/bx_bx-rotate-right.svg": "8cd6",
	"./cropper/camera-icon.svg": "a36a",
	"./cropper/delete-cropper.svg": "85f4",
	"./cropper/delete-photo.svg": "3f66",
	"./cropper/pic-icon.svg": "8c72",
	"./cropper/rotate-left.svg": "bbff",
	"./cropper/rotate-right.svg": "c5d2",
	"./cropper/upload-another.svg": "90bc",
	"./cropper/user-cropper.svg": "bd13",
	"./cropper/zoom-minus.svg": "3cde",
	"./cropper/zoom-plus.svg": "b1dc",
	"./de-flag.svg": "8288",
	"./delete-icon.svg": "cd73",
	"./delete-table-icon.svg": "f041",
	"./detail-table-icon.svg": "8042",
	"./doc-icon.svg": "0204",
	"./download-icon.svg": "2e29",
	"./edit-table-icon.svg": "d799",
	"./emer-contacts.svg": "cb49",
	"./error-icon.svg": "8f22",
	"./evolve/crown-big-icon.svg": "1135",
	"./evolve/evolve-info-icon.svg": "d5d9",
	"./evolve/evolve-info-yellow-icon.svg": "d900",
	"./file/attach-file-icon.svg": "1c60",
	"./file/attach-green.svg": "68bc",
	"./file/attach.svg": "ee2c",
	"./file/clip.svg": "5f9c",
	"./file/delete-upload.svg": "d557",
	"./file/delete-uploader-icon.svg": "888f",
	"./file/delete.svg": "c826",
	"./file/import-icon.svg": "c1b7",
	"./file/staple.svg": "1201",
	"./flight-confirmed.svg": "a068",
	"./flight-icon.svg": "3d0b",
	"./flight-note.svg": "2cb8",
	"./food-preference.svg": "d922",
	"./glyph-icon.svg": "9c01",
	"./healthcare.svg": "e922",
	"./info-block-icon.svg": "6f67",
	"./info-text-panel-icon.svg": "237e",
	"./injection.svg": "a003",
	"./insurance-icon.svg": "08f7",
	"./logo-main-black.svg": "43df",
	"./logo-main.svg": "4f57",
	"./logout.svg": "0627",
	"./luggage-icon.svg": "b043",
	"./maestro.svg": "f29d",
	"./mail.svg": "37a8",
	"./mastercard.svg": "29b8",
	"./medical.svg": "1533",
	"./modal-close.svg": "3a43",
	"./mosquito.svg": "5105",
	"./nop-icon.svg": "e9ee",
	"./notifi-error.svg": "295f",
	"./notifi-info-blue.svg": "b22b",
	"./notifi-info.svg": "a8c9",
	"./notifi-success.svg": "c223",
	"./pay-icon.svg": "b2df",
	"./payment-method-icon.svg": "000c",
	"./pcr-icon.svg": "8fc4",
	"./pen-icon.svg": "152d",
	"./pen-white-icon.svg": "b1b3",
	"./personal-details.svg": "055d",
	"./pill.svg": "7fbb",
	"./preloader.svg": "779d",
	"./print-table-icon.svg": "4b29",
	"./prod-list-arrow.svg": "ad70",
	"./rotate-arrow-to-the-left.svg": "7953",
	"./rotate-arrow-to-the-right.svg": "dda2",
	"./ru-flag.svg": "3d7b",
	"./safari-table-icon.svg": "0684",
	"./search-input.svg": "a6e1",
	"./self-icon.svg": "0eb3",
	"./services-icon.svg": "8a79",
	"./snacks-icon.svg": "81f7",
	"./soft-icon.svg": "d1e4",
	"./spoiler-arrow.svg": "d049",
	"./submit-activities.svg": "f141",
	"./success-icon.svg": "d4a9",
	"./tabs.svg": "9a98",
	"./tg.svg": "f182",
	"./tips/tips-beginning-icon.svg": "83fe",
	"./tips/tips-beginning.svg": "2da8",
	"./tips/tips-burger.svg": "d5dd",
	"./tips/tips-clock-icon.svg": "9f1b",
	"./tips/tips-clock.svg": "6aae",
	"./tips/tips-covered.svg": "a8fd",
	"./tips/tips-descent-icon.svg": "daf4",
	"./tips/tips-descent.svg": "60c8",
	"./tips/tips-device-icon.svg": "f668",
	"./tips/tips-devices.svg": "fa62",
	"./tips/tips-dollar-icon.svg": "446d",
	"./tips/tips-dollar.svg": "f20b",
	"./tips/tips-food-icon.svg": "1a22",
	"./tips/tips-food.svg": "4f45",
	"./tips/tips-gear-download.svg": "e811",
	"./tips/tips-gear-icon.svg": "ae4d",
	"./tips/tips-gear-packing.svg": "a415",
	"./tips/tips-gear.svg": "c17e",
	"./tips/tips-gps-icon.svg": "0f61",
	"./tips/tips-gps.svg": "65a2",
	"./tips/tips-heart.svg": "bbd4",
	"./tips/tips-insurance-icon.svg": "88a5",
	"./tips/tips-insurance.svg": "0c64",
	"./tips/tips-leaf.svg": "ccdb",
	"./tips/tips-list.svg": "3c2b",
	"./tips/tips-luggage-icon.svg": "5ecc",
	"./tips/tips-luggage.svg": "2310",
	"./tips/tips-mail.svg": "09df",
	"./tips/tips-medical-icon.svg": "24b5",
	"./tips/tips-medical.svg": "71b6",
	"./tips/tips-mountain-icon.svg": "c68b",
	"./tips/tips-mountain.svg": "8977",
	"./tips/tips-night-icon.svg": "32d9",
	"./tips/tips-night.svg": "c134",
	"./tips/tips-not-covered.svg": "f331",
	"./tips/tips-note.svg": "90e35",
	"./tips/tips-packing-icon.svg": "bab0",
	"./tips/tips-packing.svg": "dc1e",
	"./tips/tips-park-icon.svg": "b969",
	"./tips/tips-park.svg": "54162",
	"./tips/tips-pdf.svg": "0c66",
	"./tips/tips-personal-icon.svg": "8279",
	"./tips/tips-personal.svg": "2607",
	"./tips/tips-responsible-icon.svg": "e965",
	"./tips/tips-rest-icon.svg": "f2d5",
	"./tips/tips-rest.svg": "5a5b",
	"./tips/tips-send.svg": "9f1b5",
	"./tips/tips-shower-icon.svg": "0c99",
	"./tips/tips-shower.svg": "1b17",
	"./tips/tips-socks-icon.svg": "9f73",
	"./tips/tips-socks.svg": "bc75",
	"./tips/tips-sun.svg": "d3c8",
	"./tips/tips-support-icon.svg": "b080",
	"./tips/tips-support.svg": "0289",
	"./tips/tips-water-icon.svg": "a7ec",
	"./tips/tips-water.svg": "ceab",
	"./to-table-icon.svg": "16f4",
	"./tooltip-icon.svg": "ac1c",
	"./tour-detail-icon.svg": "0695",
	"./transfer-table-icon.svg": "5e39",
	"./unknown-icon.svg": "1e0e",
	"./us-flag.svg": "5759",
	"./view-icon.svg": "522c",
	"./visa.svg": "6180",
	"./wa.svg": "7cfc",
	"./warning-icon.svg": "97c4",
	"./warning-modal-icon.svg": "9a05",
	"./webcam-icon.svg": "fffc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";